import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { RepositoryClient } from '../httpClients/RepositoryClient';
import { BitbucketOAuthSessionResponse } from '../httpClients/RepositoryClient/api.schema';
import { QUERY_KEYS } from './consts';

type OmittedQueryOptions = Omit<
  UseQueryOptions<
    BitbucketOAuthSessionResponse,
    Error,
    BitbucketOAuthSessionResponse
  >,
  'queryKey' | 'queryFn'
>;

export const useBitbucketOAuthSessionQuery = (
  sessionId: string | undefined,
  options?: OmittedQueryOptions,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.BITBUCKET_OAUTH_SESSION, sessionId],
    queryFn: () => {
      if (!sessionId) {
        throw new Error('Session ID is required');
      }

      return RepositoryClient.bitbucketGetOAuthSession(sessionId);
    },
    enabled: !!sessionId && (options?.enabled ?? true),
    retry: false,
    ...options,
  });
